// The param-type registry a capture step's fields are declared against, and the
// discriminated union that hangs off it.
//
// `config` is resolved by POSITION: `resolver: "type"` means "look at the
// sibling `type` property, find its value's index in that property's `enum`,
// and take `oneOf[thatIndex]`" — see resolveOneOfEx in @repoflow/schema. So the
// two arrays below must stay in lockstep. Appending to one without appending to
// the other silently re-points every later type at the wrong config shape.
//
// This is wfws' OWN registry, not pagews'. The mechanism is the same one
// pagews' sections use — the runtime that compiles a declaration into a form
// is the shared @repoflow/components/types-values, and it keys on these type
// NAMES — but the set is what a person filling in a capture form can be asked
// for, which is narrower than what a page template can render:
//
//   - no `paragraph` and no `image`: both are authored in widgets that are
//     pagews' own (a Quill editor, a picker over a site's uploaded files) and
//     neither exists here.
//   - `object` names one of the workflow's SUBFORMS (`Workflow.subforms`, the
//     Subforms tab of the editor), which `stepTypes()` in ../index compiles
//     beside the step's own params — so every step of a workflow can reach
//     every subform, and a subform can nest another. `list` of `object` is a
//     table of them.
//   - `date` and `time` are two questions, not one. A `date` param stores a
//     calendar date by default — no time, no zone, because that is what a date
//     of birth or a signature date IS — and offers `format: "date-time"` for
//     the fields where the instant is the point. A `time` param stores `HH:MM`
//     and nothing else. Both are @repoflow/form-schema widgets over the same
//     react-datepicker, registered together in app/code/src/widgets/register.js;
//     they were absent until 1.7.0 shipped the second one.
//
// APPEND, NEVER INSERT, for the positional reason above.
export const properties = {};

export const types = [
  "text",
  "checkbox",
  "options",
  "number",
  "color",
  "icon",
  "list",
  "object",
  "date",
  "time",
];

export const paramProperties = {
  type: {
    label: "Type",
    type: "string",
    enum: types,
    minLength: 1,
    default: "",
  },
  config: {
    label: "Details",
    type: "object",
    oneOf: [
      { $ref: "/Types/Param/Type/Text" },
      { $ref: "/Types/Param/Type/Checkbox" },
      { $ref: "/Types/Param/Type/Options" },
      { $ref: "/Types/Param/Type/Number" },
      { $ref: "/Types/Param/Type/Color" },
      { $ref: "/Types/Param/Type/Icon" },
      { $ref: "/Types/Param/Type/List" },
      { $ref: "/Types/Param/Type/Object" },
      { $ref: "/Types/Param/Type/Date" },
      { $ref: "/Types/Param/Type/Time" },
    ],
    resolver: "type",
    default: {},
  },
};
